import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

export default class EmergencyResourcesUTSGStudent extends Component {
  render() {
    return (
      <div>
        <Row>
          <Col xs={10} xsOffset={1}>
            <h2 className="text-center txt-dkblue">
              Urgent & Emergency Resources
            </h2>
            <p>
              If you identify ​indicators that raise specific safety concerns,
              including intentions to harm self or others, they need to be
              treated with urgency. In these situations you must inform someone
              who is in a position to act, even when the person you are
              concerned about is unwilling to access these resources themselves.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={10} xsOffset={1}>
            <Col xs={12} md={6}>
              <div className="situation-grid-container">
                <div className="grid-item-heading">Emergency Situations</div>
                <div className="grid-item">
                  <div className="grid-item-info">
                    <strong>Emergency Services</strong>
                    <br />
                    <a href="tel:911">911</a>
                    <br />
                    24/7
                    <br />
                    Various, Ontario
                    <br />
                    <a href="https://crtc.gc.ca/eng/phone/911" rel="noopener noreferrer" target="_blank">
                      crtc.gc.ca/eng/phone/911
                    </a>
                  </div>
                  For life-threatening emergencies or incidents occurring in the
                  moment where you need police, fire, or ambulance. If
                  responding on campus also contact Campus Police to ensure
                  prompt service.
                </div>
                <div className="grid-item">
                  <div className="grid-item-info">
                    <strong>Campus Police</strong>
                    <br />
                    <a href="tel:416 978 2222">416 978 2222</a>
                    <br />
                    24/7
                    <br />
                    21 Sussex Ave., Suite 100
                    <br />
                    <a href="https://campuspolice.utoronto.ca" rel="noopener noreferrer" target="_blank">
                      campuspolice.utoronto.ca
                    </a>
                  </div>
                  Provides programs on personal safety, protection of property,
                  conflict resolution, maintenance of public order, community
                  services and referral, crime prevention and detection.
                </div>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className="situation-grid-container">
                <div className="grid-item-heading">Urgent Situations</div>
                <div className="grid-item">
                  <div className="grid-item-info">
                    <strong>U of T Health & Wellness Centre</strong>
                    <br />
                    <a href="tel:416 978 8030">416 978 8030</a>
                    <br />
                    Business Hours
                    <br />
                    214 College St., 2nd Floor
                    <br />
                    <a href="https://www.studentlife.utoronto.ca/hwc" rel="noopener noreferrer" target="_blank">
                      www.studentlife.utoronto.ca/hwc
                    </a>
                  </div>
                  Confidential mental health and physical health services
                  provided by an interdisciplinary team of health professionals.
                </div>
                <div className="grid-item">
                  <div className="grid-item-info">
                    <strong>Immediate On-Campus Supervisor</strong>
                    <br />
                    <span>Name: ___________________</span>
                    <br />
                    <span>Contact: __________________</span>
                  </div>
                  <span>
                    Whether a referral is made or not - if you are supporting
                    someone as a result of your role as a student leader, staff
                    or faculty member, you should inform your supervisor and/ or
                    the appropriate contact within your unit.
                  </span>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/IARReference/EmergencyResources/EmergencyResourcesUTSGStudent.js